/**
 * assetUrl — a path under the add-in's `public/` folder, resolved against the
 * Vite base path the pane is served from.
 *
 * `import.meta` is read through `Function` so jest (CommonJS) can import this
 * module; outside Vite the base is "/".
 */
function baseUrl(): string {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const meta = Function(
      "return typeof import.meta !== 'undefined' ? import.meta : null",
    )() as any;
    if (meta?.env?.BASE_URL) return String(meta.env.BASE_URL);
  } catch {
    /* fall through */
  }
  return "/";
}

export function assetUrl(path: string): string {
  return `${baseUrl()}${path.replace(/^\/+/, "")}`;
}

/** The ora wordmark with the firefly — the brand bar's logo. */
export function oraLogoUrl(): string {
  return assetUrl("assets/ora_logo.png");
}
